import React, { useState } from 'react';
import PropTypes from 'prop-types';
import 'components/styles/employee-record.css';
import DeLinkDialog from 'components/delink-dialog';
import DeleteDialog from './delete-dialog';
import { ReactComponent as DelinkIcon } from 'assets/images/de-link.svg';
import { ReactComponent as DeleteIcon } from 'assets/images/delete.svg';

const EmployeeRecord = ({
  employeeData = {},
  setShowDelinkSuccessMessage,
  setShowDeleteSuccessMessage
}) => {
  const [showDeLinkDialog, setShowDeLinkDialog] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const {employeeCode = '' , partner = '' , cardNumber = ''} = employeeData || {};

  const bodyStyles = showDeLinkDialog ? { opacity: 0.4, background: 'black' } : {};

  return (
    <>
      <div className="record-container">
        {showDeLinkDialog && (
          <DeLinkDialog
            onClose={() => setShowDeLinkDialog(false)}
            setShowDelinkSuccessMessage={setShowDelinkSuccessMessage}
            employeeData={employeeData}
          />
        )}

        {showDeleteDialog && (
          <DeleteDialog
            onClose={() => setShowDeleteDialog(false)}
            setShowDeleteSuccessMessage={setShowDeleteSuccessMessage}
            employeeData={employeeData}
          />
        )}

        <div className="record-table" style={bodyStyles}>
          <div className="record-column employee-id">
            <div className="record-header">Employee ID</div>
            <div className="record-value">{employeeCode}</div>
          </div>

          <div className="record-column company-code">
            <div className="record-header">Company code</div>
            <div className="record-value">{partner.code}</div>
          </div>

          <div className="record-column loyalty-card-number">
            <div className="record-header">Loyalty card number</div>
            <div className="record-value">
              {cardNumber ? cardNumber : 'NA'}
            </div>
          </div>

          <div className="record-actions">
            <div className="record-column de-link">
              <div className="record-header">De-link</div>
              <div className="record-value">
                <div
                  className={`${
                    cardNumber ? 'record-button-delink' : 'disableDelink'
                  }`}
                  onClick={() => {
                    if (cardNumber) {
                      setShowDeLinkDialog(true);
                    }
                  }}>
                  <div className="icon">
                    <DelinkIcon/>
                  </div>
                  <div className="text">De-link</div>
                </div>
              </div>
            </div>

            <div className="record-column delete" onClick={() => setShowDeleteDialog(true)}>
              <div className="record-header">Delete</div>
              <div className="record-value">
                <div className="record-button-delete">
                  <div className="icon">
                    <DeleteIcon/>
                  </div>
                  <div className="text">Delete</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {(showDeLinkDialog || showDeleteDialog) && (
        <div className="body-overlay" style={bodyStyles}></div>
      )}
    </>
  );
};

EmployeeRecord.propTypes = {
  employeeData: PropTypes.object,
  setShowDelinkSuccessMessage: PropTypes.func,
  setShowDeleteSuccessMessage: PropTypes.func
};

export default EmployeeRecord;
